var render, staticRenderFns
import script from "./DossierCount.vue?vue&type=script&lang=js&"
export * from "./DossierCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d60415",
  null
  
)

export default component.exports